import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import styles from '../MuslinTwoLayer/MuslinTwoLayer.module.scss'
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs'
import CarouselPhoto from '../../../components/CarouselPhoto/CarouselPhoto'
import { arrSatin } from '../../../utils/data'
import WidthDensity from '../../../components/WidthDensity/WidthDensity'
import ColorsList from '../../../components/ColorsList/ColorsList'
import Popular from '../../../components/Popular/Popular'
import { arrPopular } from '../../../utils/data'



const Satin = ({isOpen}) => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

        return (
            <section 
            className={styles.main} 
            >
            <BreadCrumbs
                text={'Сатин'}
            >
                <p className={styles.menu_text}><span>&ensp;/&ensp;</span></p>
                <Link className={styles.menu_link} to='/tkani'>Ткани в наличии</Link>
            </BreadCrumbs>
            <div className={styles.box}>
                <div className={styles.list_image}>
                    <CarouselPhoto
                        arr={arrSatin}
                    />
                </div>
                <div className={styles.box_info}>
                    <div>
                        <h2 className={styles.title}>Сатин</h2>
                        <p className={styles.subtitle}>тканое полотно</p>
                    </div>
                    <div className={styles.line}></div>
                        <WidthDensity
                            type='93 нити'
                            width='190'
                            density='150'
                        />
                        <WidthDensity
                            type='83 нити'
                            width='240'
                            density='135'
                        />
                        <WidthDensity
                            type='93 нити'
                            width='280'
                            density='145'
                        />
                        <WidthDensity
                            type='120 нитей'
                            width='300'
                            density='130'
                        />
                        <div className={styles.line}></div>
                        <ColorsList
                        arr={arrSatin}
                        />
                        <button className={styles.button} type='button' onClick={isOpen}>заказать сатин</button>
                </div>
            </div>
            <Popular
                arr={arrPopular}
            />  
            </section>
        )
    }
    
    export default Satin